'use client'

import { useSubaccountDiscovery } from './useSubaccountDiscovery'

/**
 * Provider component that initializes subaccount discovery on wallet connect.
 *
 * This should be placed near the root of the app, inside the WagmiProvider.
 * It automatically:
 * - Discovers active subaccounts when a wallet connects
 * - Refreshes the cache when it becomes stale (after ~100 blocks)
 * - Resets state when the wallet disconnects or changes
 *
 * All child components can then use `useSubaccountStore` to access
 * the cached active subaccount IDs without making additional RPC calls.
 */
export function SubaccountProvider({ children }: { children: React.ReactNode }) {
  // This hook handles all the discovery logic
  useSubaccountDiscovery()

  return <>{children}</>
}
